<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="grid">
        <div class="col-12">
          <div class="formgrid grid">
            <div class="field col-12 md:col-12">
              <label>Divisi</label>
              <Dropdown
                ref="parent_id"
                v-model="form.parent_id"
                :filter="true"
                :options="listDivisi"
                class="w-full"
                :class="{
                  'p-invalid': v$.form.parent_id.$invalid && submitted,
                }"
                input-class="w-full"
                optionValue="id"
                optionLabel="name"
                disabled
                @keydown="handleKeydownField($event, 'ctg')"
              />
              <small
                v-if="
                  (v$.form.parent_id.$invalid && submitted) ||
                  v$.form.parent_id.$pending.$response
                "
                class="p-error"
                >{{ v$.form.parent_id.required.$message }}</small
              >
            </div>
            <div class="field col-12 md:col-12">
              <label>Kode Departemen (Opsional)</label>
              <InputText
                ref="ctg"
                v-model="form.ctg"
                type="text"
                class="w-full"
                input-class="w-full"
                maxlength="3"
                @keydown="handleKeydownField($event, 'name')"
              />
              <small
                v-if="
                  this.editMode == true &&
                  (this.form.ctg == '' || this.form.ctg == null)
                "
                class="p-error"
                >Kode departemen tidak boleh kosong</small
              >
              <small class="text-500">
                Kode otomatis dibuat sistem, tetapi masih dapat diubah.
              </small>
            </div>
            <div class="field col-12 md:col-12">
              <label>Nama Departemen</label>
              <InputText
                ref="name"
                v-model="form.name"
                :class="{ 'p-invalid': v$.form.name.$invalid && submitted }"
                class="w-full"
                input-class="w-full"
                maxlength="40"
                @keydown="handleKeydownField($event, 'std_mrg', true)"
              />
              <small
                v-if="
                  (v$.form.name.$invalid && submitted) ||
                  v$.form.name.$pending.$response
                "
                class="p-error"
                >{{ v$.form.name.required.$message }}</small
              >
            </div>
            <div class="field col-12 md:col-6">
              <label>STD Margin</label>
              <div
                class="p-inputgroup col-12 md:col-12"
                style="margin-left: -10px"
              >
                <InputNumber
                  ref="std_mrg"
                  v-model="form.std_mrg"
                  :class="{
                    'p-invalid': v$.form.std_mrg.$invalid && submitted,
                  }"
                  :minFractionDigits="0"
                  :maxFractionDigits="2"
                  locale="id-ID"
                  :min="0"
                  :max="100"
                  class="w-full"
                  @keydown="handleKeydownField($event, 'btnSave')"
                />
                <span class="p-inputgroup-addon">%</span>
              </div>
              <small
                v-if="
                  (v$.form.std_mrg.$invalid && submitted) ||
                  v$.form.std_mrg.$pending.$response
                "
                class="p-error"
                >{{ v$.form.std_mrg.required.$message }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
          ref="btnSave"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { focusNextField, handleKeydownField } from '@/helpers'
import DepartemenService from '@/services/DepartemenService'
import useVuelidate from '@vuelidate/core'
import { helpers, numeric, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    listDivisi: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  created() {
    this.departemenService = new DepartemenService()
  },
  async mounted() {
    if (!this.editMode) {
      const res = await this.departemenService.generateCode(this.form.parent_id)
      this.form.ctg = res.data.ctg
    }
    this.$nextTick(() => {
      setTimeout(() => {
        focusNextField(this, 'ctg')
      }, 100)
    })
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true

      if (
        this.editMode == true &&
        (this.form.ctg == '' || this.form.ctg == null)
      ) {
        return
      }

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
    },
    handleKeydownField(event, nextRef, selectAll = false) {
      handleKeydownField(this, event, nextRef, selectAll)
    },

    focusNextField(refName, selectAll = false) {
      focusNextField(this, refName, selectAll)
    },
  },
  validations() {
    return {
      form: {
        parent_id: {
          required: helpers.withMessage('Divisi harus dipilih.', required),
        },
        name: {
          required: helpers.withMessage('Nama harus diisi.', required),
        },
        std_mrg: {
          required: helpers.withMessage(
            'STD Margin harus diisi dengan angka',
            required
          ),
          numeric,
        },
      },
    }
  },
}
</script>
